import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { APP_CONFIG, AppConfig } from '../../../shared-service/app.config';
import { BaseService } from './../../../shared-service/base.service';
import { OverviewService } from '../overview.service';

@Component({
  selector: 'upcomingevent',
  templateUrl: './upcomingevent.component.html',
  styleUrls: ['./upcomingevent.component.css']
})

export class UpcomingeventComponent implements OnInit {

  loader: boolean = true;
  MyTask: Array<any> = [];
  CurrentDate: string = '';
  TaskCount: number = 0;

  constructor(public bs: BaseService, private os: OverviewService,private router: Router) { }

  ngOnInit() {
    const params: Object = {};
    this.os.getOverViewMyTaskData(params, '****').then((data:any) => {
      this.CurrentDate = data['CurrentDate'];
      this.MyTask=data['MyTaskList'];
      this.TaskCount = this.MyTask.length;
      this.loader = false;
    }, (data) => {
      this.loader = false;
    });
  }

  openLearningItem(id:any, type:any) {
    if (type == 'T') {
        this.router.navigate([this.bs.getFullPath('ilt_dtl'), { tab: '', id: id }]);
    } else if ((type == 'C') || (type == 'P')) {
        this.router.navigate([this.bs.getFullPath('crs_dtl'), { CourseLaunchId: '', tab: '', id: id, gamificationPoints: 0, IsNodeClick: false }]);
    }
  }
}